/**
 * 매수고객 관리(CS, 2026-09-23): 자동보류 D-day 배지·제외 사유 라벨.
 *
 * D-day 는 서버가 계산해 준다(backend/util/clientList.util.js).
 *   hold_dday = 마지막 상담일(없으면 등록일) + N일 - 오늘. 제외 고객·관리/계약이 아닌 고객은 null.
 *   N(days)과 알림 시점(alertDays)은 CZ 부터 관리자 설정이다. 서버가 목록·카드 응답에 함께 준다.
 * 이 파일은 그 숫자를 화면 글자와 색으로 바꾸기만 한다. 목록(UserAdmin)과 고객 카드(UserDetail)가
 * 같은 규칙을 쓰게 한 곳에 둔다.
 */

// 자동보류 제외 사유는 CY(2026-10-07)부터 관리자가 고치는 목록(서버 client_hold_reason)이다. 화면은 서버가
// 준 이름(hold_exempt_reason_name, exempt.reason_name)을 그대로 쓰고 여기 사유 목록을 두지 않는다.

// 변경내역 탭의 '변경구분' 라벨. seon.js 의 CLIENT_LOG_TYPE 에 없는 새 키만 여기 둔다.
export const CLIENT_LOG_TYPE_EXTRA = {
	hold_exempt: '자동보류제외',
	merge: '고객병합',
};

/**
 * 목록 행이나 카드 상태 → { text, sub, level, title }. exemptReasonName 이 없으면 키를 그대로 쓴다.
 *   level: exempt | none | normal | soon(알림 시점 이내, 기본 7일) | urgent(3일 이내·당일) | over(지남)
 */
export function holdBadge({ dday, exemptReason, exemptReasonName, exemptMemo, baseDate, days = 30, alertDays = 7 }) {
	if (exemptReason) {
		const name = exemptReasonName || exemptReason;
		const why = name + (exemptMemo ? ` (${exemptMemo})` : '');
		return { text: '자동보류 제외', sub: name, level: 'exempt', title: `자동보류 제외: ${why}` };
	}
	if (dday == null) return { text: '-', sub: '', level: 'none', title: '' };
	const base = baseDate ? `마지막 상담 ${baseDate} 기준 ${days}일` : `마지막 상담 기준 ${days}일`;
	if (dday < 0) {
		return { text: '자동보류', sub: `+${-dday}일`, level: 'over', title: `${base}이 ${-dday}일 지났습니다` };
	}
	if (dday === 0) return { text: 'D-DAY', sub: '', level: 'urgent', title: `${base}이 오늘 끝납니다` };
	const urgent = Math.min(3, alertDays);
	const level = dday <= urgent ? 'urgent' : dday <= alertDays ? 'soon' : 'normal';
	return { text: `D-${dday}`, sub: '', level, title: `${base}까지 ${dday}일 남았습니다` };
}
